// Profile pictures are stored on the backend as bare filenames (e.g. "42.jpg")
// and served from {scope.base}/images/{role|profile-pic}/{detailId}/{filename}
// where {scope.base} is `/admin`, `/managers/{id}`, or `/trainers/{id}`.
// The route is auth-protected and lives behind EnsureRequestFromApp, so it
// can't be loaded via plain <img src> — it needs the full request headers.
// Use `useAuthedImage(path)` to fetch the bytes and turn them into a blob URL.
import { activeScope } from '@/api/scope';

export type ProfilePicRole = 'admin' | 'trainer' | 'manager' | 'student';

export function profilePicPath(
  role: ProfilePicRole,
  detailId: number | string | null | undefined,
  filename: string | null | undefined,
): string | null {
  if (!filename || !filename.trim()) return null;
  const scope = activeScope();
  const base = scope.base; // `/admin`, `/managers/{id}`, or `/trainers/{id}`

  // The session owner's own picture is keyed only by filename (no id segment):
  //  - admin session → /admin/images/profile-pic/{file}
  //  - manager session viewing their own → /managers/{mid}/images/profile-pic/{file}
  //  - trainer session viewing their own → /trainers/{tid}/images/profile-pic/{file}
  const ownRole = scope.role; // 'admin' | 'manager' | 'trainer'
  if (role === ownRole) {
    return `${base}/images/profile-pic/${encodeURIComponent(filename)}`;
  }

  if (!detailId) return null;
  const segment =
    role === 'trainer' ? 'trainer' : role === 'manager' ? 'manager' : 'student';
  return `${base}/images/${segment}/${encodeURIComponent(String(detailId))}/${encodeURIComponent(filename)}`;
}
